<!-- content begin -->
<div id="content" class="no-bottom no-top">
  <div id="top"></div>

  <!-- section begin -->
  <section
    id="subheader"
    class="text-light"
    data-bgimage="url(assets/images/background/13.jpg)"
    data-stellar-background-ratio=".2"
    style="background: url(/assets/images/background/16.jpg) 0% 0px / cover; "
  >
    <div class="overlay-bg t50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1> Registration Form</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->

  <!-- section begin -->
  <section id="section-services" data-bgcolor="#f9f9f9">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="card m-3">
            <div class="card-body">
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                  <h3>Personal Details</h3>
                  <div class="form-row">
                        <div class="form-group col-4">
                            <label>Name (In BLOCK letters) *</label>
                            <input type="text" formControlName="name" (keypress)="omit_text($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.name.errors }" maxlength="50" />
                            <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                <div *ngIf="f.name.errors.required">Your Name is required</div>
                            </div>
                        </div>
                        <div class="form-group col-4">
                          <label>Gender</label>
                          <select formControlName="gender" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.gender.errors }">
                              <option value="" disabled>Select Gender</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                              <option value="transgender">Transgender</option>
                          </select>
                          <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                              <div *ngIf="f.gender.errors.required">Gender is required</div>
                          </div>
                      </div>
                        <div class="form-group col-4">
                            <label>DOB</label>
                            <input
                            theme="dp-material"
                            class="form-control"
                            formControlName="dob"
                            [dpDayPicker]="datePickerConfig"
                            [ngClass]="{ 'is-invalid': submitted && f.dob.errors }"
                            placeholder="Date Of Birth"
                            maxlength="10"
                          />
                            <!-- <input type="text" formControlName="dob" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dob.errors }" /> -->
                            <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                                <div *ngIf="f.dob.errors.required">DOB is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">

                      <div class="form-group col-4">
                          <label>Father's Name * </label>
                          <input type="text" formControlName="fathername" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.fathername.errors }" (keypress)="omit_text($event)" maxlength="50" />
                          <div *ngIf="submitted && f.fathername.errors" class="invalid-feedback">
                              <div *ngIf="f.fathername.errors.required">Father Name is required</div>
                          </div>
                      </div>
                      <div class="form-group col-4">
                        <label>Mobile Number *</label>
                        <input type="text" formControlName="mobilenumber" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.mobilenumber.errors }" (keypress)="omit_number($event)" maxlength="10"/>
                        <div *ngIf="submitted && f.mobilenumber.errors" class="invalid-feedback">
                            <div *ngIf="f.mobilenumber.errors.required">Mobile Number is required</div>
                        </div>
                        <div *ngIf="submitted && f.mobilenumber.errors" class="invalid-feedback">
                          <div *ngIf="f.mobilenumber.errors.pattern">Enter only number</div>
                      </div>
                       </div>

                      <div class="form-group col-4">
                        <label>Email Address *</label>
                        <input type="text" formControlName="email" class="form-control" (keypress)="omit_email($event)" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" maxlength="30"  />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                        </div>
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                          <div *ngIf="f.email.errors.pattern">Valid Email Address</div>
                      </div>
                      </div>
                    </div>
                    <div class="form-row">

                      <div class="form-group col-4">
                          <label>Selected Marital Status * </label>
                          <select formControlName="maritalstatus" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.maritalstatus.errors }">
                            <option value="" disabled>Select Status</option>
                            <option value="married">Married</option>
                            <option value="widowed">Widowed</option>
                            <option value="separated">Separated</option>
                            <option value="divorced">Divorced</option>
                            <option value="single">Single</option>
                        </select>
                        <div *ngIf="submitted && f.maritalstatus.errors" class="invalid-feedback">
                            <div *ngIf="f.maritalstatus.errors.required">Marital status is required</div>
                        </div>
                      </div>

                      <div class="form-group col-4">
                        <label>Category *</label>
                        <select formControlName="category" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.category.errors }">
                            <option value="" disabled>Select Category</option>
                            <option value="general">GENERAL</option>
                            <option value="obc">OBC</option>
                            <option value="sc">SC</option>
                            <option value="st">ST</option>
                            <option value="ews">EWS</option>
                        </select>
                        <div *ngIf="submitted && f.category.errors" class="invalid-feedback">
                            <div *ngIf="f.category.errors.required">Category is required</div>
                        </div>
                       </div>

                      <div class="form-group col-4">
                        <label>DIVYANG *</label>
                        <select formControlName="divyang" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.divyang.errors }">
                          <option value="" disabled>Select DIVYANG</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                      </select>
                      <div *ngIf="submitted && f.divyang.errors" class="invalid-feedback">
                          <div *ngIf="f.divyang.errors.required">DIVYANG is required</div>
                      </div>
                      </div>

                      <div class="form-group col-4">
                        <label>Nationality *</label>
                        <input type="text" formControlName="nationality" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.nationality.errors }" />
                        <div *ngIf="submitted && f.nationality.errors" class="invalid-feedback">
                            <div *ngIf="f.nationality.errors.required">Nationality is required</div>
                        </div>

                      </div>

                    </div>

                    <hr>


                    <h3>Permanent Address</h3>
                    <div class="form-row">

                      <div class="form-group col-4">
                          <label>Door Number * </label>
                          <input type="text" formControlName="doorno" class="form-control" (keypress)="omit_spl($event)" [ngClass]="{ 'is-invalid': submitted && f.doorno.errors }" maxlength="50"/>
                          <div *ngIf="submitted && f.doorno.errors" class="invalid-feedback">
                              <div *ngIf="f.doorno.errors.required">Door Number is required</div>
                          </div>
                      </div>
                      <div class="form-group col-4">
                        <label>Street Name *</label>
                        <input type="text" formControlName="streetname" class="form-control"  (keypress)="omit_addres($event)"  [ngClass]="{ 'is-invalid': submitted && f.streetname.errors }" maxlength="100" />
                          <div *ngIf="submitted && f.streetname.errors" class="invalid-feedback">
                              <div *ngIf="f.streetname.errors.required">Street Name is required</div>
                          </div>
                       </div>

                      <div class="form-group col-4">
                        <label>Area *</label>
                        <input type="text" formControlName="area" class="form-control" (keypress)="omit_addres($event)"  [ngClass]="{ 'is-invalid': submitted && f.area.errors }" maxlength="100" />
                        <div *ngIf="submitted && f.area.errors" class="invalid-feedback">
                            <div *ngIf="f.area.errors.required">Area is required</div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row">

                      <div class="form-group col-4">
                          <label> Village / Town / City * </label>
                          <input type="text" formControlName="vtc" class="form-control" (keypress)="omit_addres($event)"  [ngClass]="{ 'is-invalid': submitted && f.vtc.errors }" maxlength="100" />
                          <div *ngIf="submitted && f.vtc.errors" class="invalid-feedback">
                              <div *ngIf="f.vtc.errors.required">Village / Town / City is required</div>
                          </div>
                      </div>
                      <div class="form-group col-4">
                        <label>Pincode *</label>
                        <input type="text" formControlName="pincode" class="form-control" (keypress)="omit_addres($event)"  [ngClass]="{ 'is-invalid': submitted && f.pincode.errors }" maxlength="6" />
                          <div *ngIf="submitted && f.pincode.errors" class="invalid-feedback">
                              <div *ngIf="f.pincode.errors.required">Pincode is required</div>
                          </div>
                       </div>

                      <div class="form-group col-4">
                        <label>State *</label>
                        <select
                    formControlName="state"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.state.errors }"
                    (change)="onChangeState($event)"
                  >
                    <option [selected]="true" value="" [disabled]="true">Select State</option>
                    <option
                      *ngFor="let country of state"
                      [value]="country.state_name"
                    >
                      {{ country.state_name }}
                    </option>
                  </select>

                      <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                          <div *ngIf="f.state.errors.required">State is required</div>
                      </div>
                      </div>
                    </div>

                    <div class="form-row">

                      <div class="form-group col-4">
                        <label>District *</label>
                        <select
                    formControlName="district"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.district.errors }"
                    (change)="onChangeDist($event)"
                  >
                  <option [selected]="true" value="" [disabled]="true">Select District</option>
                    <option
                      *ngFor="let country of district"
                      [value]="country.district_name"
                    >
                      {{ country.district_name }}
                    </option>
                  </select>
                      <div *ngIf="submitted && f.district.errors" class="invalid-feedback">
                          <div *ngIf="f.district.errors.required">District is required</div>
                      </div>
                      </div>

                      <div class="form-group col-4" *ngIf="bool_crntAddress">
                        <label>Same Addres</label>
                        <select
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.district.errors }"
                    (change)="onChangeAddress($event)"
                  >
                  <option [selected]="true" value="" [disabled]="true">Select District</option>
                    <option value="yes"> Yes </option>
                    <option value="no"> No </option>
                  </select>
                      <div *ngIf="submitted && f.district.errors" class="invalid-feedback">
                          <div *ngIf="f.district.errors.required">District is required</div>
                      </div>
                      </div>
                    </div>


                    <hr>

                    <h3>Communication Address</h3>

                    <div class="form-row">

                      <div class="form-group col-4">
                          <label>Door Number * </label>
                          <input type="text" formControlName="c_doorno" [(ngModel)]="dup_doorno" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_doorno.errors }" maxlength="10" />
                          <div *ngIf="submitted && f.c_doorno.errors" class="invalid-feedback">
                              <div *ngIf="f.c_doorno.errors.required">Door Number is required</div>
                          </div>
                      </div>
                      <div class="form-group col-4">
                        <label>Street Name *</label>
                        <input type="text" formControlName="c_streetname" [(ngModel)]="dup_street" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_streetname.errors }" />
                          <div *ngIf="submitted && f.c_streetname.errors" class="invalid-feedback">
                              <div *ngIf="f.c_streetname.errors.required">Street Name is required</div>
                          </div>
                       </div>

                      <div class="form-group col-4">
                        <label>Area *</label>
                        <input type="text" formControlName="c_area" [(ngModel)]="dup_area" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_area.errors }" maxlength="50" />
                        <div *ngIf="submitted && f.c_area.errors" class="invalid-feedback">
                            <div *ngIf="f.c_area.errors.required">Area is required</div>
                        </div>
                      </div>
                    </div>

                    <div class="form-row">

                      <div class="form-group col-4">
                          <label> Village / Town / City * </label>
                          <input type="text" formControlName="c_vtc" [(ngModel)]="dup_vtc" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.vtc.errors }" maxlength="50" />
                          <div *ngIf="submitted && f.vtc.errors" class="invalid-feedback">
                              <div *ngIf="f.vtc.errors.required">Village / Town / City is required</div>
                          </div>
                      </div>
                      <div class="form-group col-4">
                        <label>Pincode *</label>
                        <input type="text" formControlName="c_pincode" [(ngModel)]="dup_pincode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_pincode.errors }" maxlength="6" />
                          <div *ngIf="submitted && f.c_pincode.errors" class="invalid-feedback">
                              <div *ngIf="f.c_pincode.errors.required">Pincode is required</div>
                          </div>
                       </div>

                      <div class="form-group col-4">
                        <label>State *</label>
                        <select
                    formControlName="c_state"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.c_state.errors }"
                    (change)="onChangeState($event)" [(ngModel)]="dup_state"
                  >
                    <option [selected]="true" value="" [disabled]="true">Select State</option>
                    <option
                      *ngFor="let country of state"
                      [value]="country.state_name"
                    >
                      {{ country.state_name }}
                    </option>
                  </select>
                      <div *ngIf="submitted && f.c_state.errors" class="invalid-feedback">
                          <div *ngIf="f.c_state.errors.required">State is required</div>
                      </div>
                      </div>
                    </div>

                    <div class="form-row">

                      <div class="form-group col-4">
                        <label>District *</label>
                        <select
                    formControlName="c_district"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.c_district.errors }" [(ngModel)]="dup_district"
                  >
                  <option [selected]="true" value="" [disabled]="true">Select District</option>
                    <option
                      *ngFor="let country of district"
                      [value]="country.district_name"
                    >
                      {{ country.district_name }}
                    </option>
                  </select>
                      <div *ngIf="submitted && f.c_district.errors" class="invalid-feedback">
                          <div *ngIf="f.c_district.errors.required">District is required</div>
                      </div>
                      </div>
                    </div>

                    <hr>


                    <div class="form-row">

                      <div class="form-group col-12">
                        <label>Educational Qualifications</label>
                        <table class="table table-bordered" formArrayName="qualification">
                          <thead>
                            <tr>
                              <th> Examinaton</th>
                              <th>Year of Passing</th>
                              <th> Board / University</th>
                              <th>Subject</th>
                              <th>Division / marks %</th>
                              <th> <button type="button" (click)="addQualification()" >Add </button></th>

                            </tr>
                          </thead>
                          <tr>
                            <!-- <th colspan="2">Add Multiple Quantity:</th> -->
                            <!-- <th width="150px"></th> -->
                          </tr>
                          <tr *ngFor="let quantity of qualification().controls; let i=index" [formGroupName]="i">
                            <td>
                                <!-- Quantity : -->
                                <input type="text" formControlName="exampassed" class="form-control" (keypress)="omit_spl($event)"  maxlength="50">
                            </td>
                            <td>
                                <!-- Price: -->
                                <input type="text" formControlName="yearpass" (keypress)="omit_number($event)" class="form-control" maxlength="4">
                            </td>
                            <td>
                              <!-- Price: -->
                              <input type="text" formControlName="university" (keypress)="omit_text($event)" class="form-control" maxlength="50">
                          </td>
                          <td>
                              <!-- Price: -->
                              <input type="text" formControlName="substudied"  (keypress)="omit_text($event)" class="form-control" maxlength="50">
                          </td>
                          <td>
                              <!-- Price: -->
                              <input type="text" formControlName="marks" class="form-control"  (keypress)="omit_decimal($event)" class="form-control" maxlength="4">
                          </td>
                            <td>
                                <button *ngIf="i >= 0" (click)="removeQualification(i)" class="btn btn-danger">Remove</button>

                            </td>
                          </tr>
                        </table>

                      </div>
                    </div>

                    <hr>


                    <div class="form-row">

                      <div class="form-group col-12">
                        <label>Professional / Technical Qualifications</label>
                        <table class="table table-bordered" formArrayName="professional">
                          <thead>
                            <tr>
                              <th> Examinaton</th>
                              <th>Year of Passing</th>
                              <th>Details of Course</th>
                              <th> Board / University</th>
                              <th>Subject</th>
                              <th>CGPA</th>
                              <th> <button type="button" (click)="addprofessional()" >Add </button></th>

                            </tr>
                          </thead>
                          <tr>
                            <!-- <th colspan="2">Add Multiple Quantity:</th> -->
                            <!-- <th width="150px"></th> -->
                          </tr>
                          <tr *ngFor="let quantity of professional().controls; let j=index" [formGroupName]="j">
                            <td>
                                <!-- Quantity : -->
                                <input type="text" formControlName="exampassed" class="form-control" (keypress)="omit_text_number($event)" maxlength="50">
                            </td>
                            <td>
                                <!-- Price: -->
                                <input type="text" formControlName="yearpass" class="form-control" (keypress)="omit_text_number($event)" maxlength="4">
                            </td>
                            <td>
                              <!-- Price: -->
                              <input type="text" formControlName="course" class="form-control" (keypress)="omit_text_number($event)" maxlength="50">
                          </td>
                            <td>
                              <!-- Price: -->
                              <input type="text" formControlName="university" class="form-control" (keypress)="omit_text_number($event)" maxlength="50">
                          </td>
                          <td>
                              <!-- Price: -->
                              <input type="text" formControlName="substudied" class="form-control" (keypress)="omit_text_number($event)" maxlength="50" >
                          </td>
                          <td>
                              <!-- Price: -->
                              <input type="text" formControlName="marks" class="form-control" (keypress)="omit_decimal($event)" maxlength="4">
                          </td>
                            <td>
                                <button *ngIf="j >= 0" (click)="removeprofessional(j)" class="btn btn-danger">Remove</button>

                            </td>
                          </tr>
                        </table>

                      </div>
                    </div>
                    <hr>
                    <div class="form-row">

                      <div class="form-group col-12">
                        <label>A Breif Writeup of Past experience *</label>
                        <textarea maxlength="999" formControlName="pastexperience" placeholder="maximum type 1000 charactor" class="form-control" style="resize: none;">

                        </textarea>
                        <!-- <input type="text" formControlName="c_pincode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.c_pincode.errors }" />
                          <div *ngIf="submitted && f.c_pincode.errors" class="invalid-feedback">
                              <div *ngIf="f.c_pincode.errors.required">Pincode is required</div>
                          </div> -->
                      </div>
                    </div>
                    <hr>

                    <div class="form-row">

                      <div class="form-group col-12">
                        <label>Work Experience in chronological order</label>
                        <table class="table table-bordered" formArrayName="workexp">
                          <thead>

                            <tr>
                              <th> Name & Address of Employer</th>
                              <th > Period of Service From </th>
                              <th> Period of Service To </th>
                              <th> Designation of post & scale of Pay</th>
                              <th> Total length of Service</th>
                              <th>Nature of work & level of responsiblites</th>

                              <th> <button type="button" (click)="addworkexp()" >Add </button></th>

                            </tr>
                          </thead>
                          <tr>
                            <!-- <th colspan="2">Add Multiple Quantity:</th> -->
                            <!-- <th width="150px"></th> -->
                          </tr>
                          <tr *ngFor="let quantity of workexp().controls; let k=index" [formGroupName]="k">
                            <td>
                                <!-- Quantity : -->
                                <input type="text" formControlName="addressofemp" class="form-control"  (keypress)="omit_text_number($event)" maxlength="50">
                            </td>
                            <td>
                                <!-- Price: -->
                                <input type="text" formControlName="from" class="form-control" (keypress)="omit_number($event)" maxlength="4">
                            </td>
                            <td>
                              <!-- Price: -->
                              <input type="text" formControlName="to" class="form-control"  (keypress)="omit_number($event)" maxlength="4">
                          </td>
                            <td>
                              <!-- Price: -->
                              <input type="text" formControlName="scaleofpay" class="form-control"  (keypress)="omit_number($event)" maxlength="8">
                          </td>
                          <td>
                              <!-- Price: -->
                              <input type="text" formControlName="service" class="form-control"  (keypress)="omit_text_number($event)" maxlength="8">
                          </td>
                          <td>
                              <!-- Price: -->
                              <input type="text" formControlName="naturework" class="form-control"  (keypress)="omit_text_number($event)" maxlength="50">
                          </td>
                            <td>
                                <button *ngIf="k >= 0" (click)="removeworkexp(k)" class="btn btn-danger">Remove</button>

                            </td>
                          </tr>
                        </table>

                      </div>
                    </div>
                    <hr>
                    <div class="form-row">

                      <div class="form-group col-4">
                        <label>Organization type *</label>
                        <select formControlName="presently" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.presently.errors }">
                          <option disabled value=""></option>
                          <option value="govt">Govt</option>
                          <option value="psu">PSU</option>
                          <option value="autonomus">Autonomous Institutions</option>
                          <option value="private">Private</option>
                      </select>
                          <div *ngIf="submitted && f.presently.errors" class="invalid-feedback">
                              <div *ngIf="f.presently.errors.required">Presently job is required</div>
                          </div>
                      </div>
                      <div class="form-group col-4">
                        <label>Job type *</label>
                        <select formControlName="present" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.present.errors }">
                          <option disabled value=""></option>
                          <option value="permenant">Permenant</option>
                          <option value="temporory">Temporory</option>
                          <option value="adhoc">Ad-Hoc</option>
                      </select>
                          <div *ngIf="submitted && f.present.errors" class="invalid-feedback">
                              <div *ngIf="f.present.errors.required">present job is required</div>
                          </div>
                      </div>
                      <div class="form-group col-12">
                        <label>Any other Relevent Information </label>

                        <input type="text" formControlName="relevent" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.relevent.errors }" />
                          <div *ngIf="submitted && f.relevent.errors" class="invalid-feedback">
                              <div *ngIf="f.relevent.errors.required">Relevent Information is required</div>
                          </div>
                      </div>
                    </div>
                    <hr>
                    <div class="form-row">

                      <div class="form-group col-4">
                        <label> Post Apply For SANKALP *</label>
                        <select formControlName="applypost" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.applypost.errors }">
                          <option value=""></option>
                          <option value="sankalp">Senior Consultant</option>
                          <option value="sankalp">Consultant IIS</option>
                          <option value="sankalp">Consultant </option>
                          <option value="sankalp">Associate  </option>
                      </select>
                          <div *ngIf="submitted && f.applypost.errors" class="invalid-feedback">
                              <div *ngIf="f.applypost.errors.required">Apply Post is required</div>
                          </div>
                      </div>
                    </div>
                    <hr>

                    <div class="form-row">

                      <div class="form-group col-4">
                        <label>Upload Recent Photo *</label>
                        <input type="file" formControlName="image" id="customFile" name="uploadedImage" (change)="onFileSelect($event)" #UploadFileInput>
                        <!-- <input type="file" formControlName="image" (change)="handleFileInput($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.image.errors }" /> -->
                        <div *ngIf="submitted && f.image.errors" class="invalid-feedback">
                            <div *ngIf="f.image.errors.required">Last Name is required</div>
                        </div>
                      </div>

                      <div class="form-group col-4">
                        <label>Upload Certificate *</label>
                        <input type="file" formControlName="certificate" (change)="handleFileInput($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.certificate.errors }" />
                        <div *ngIf="submitted && f.certificate.errors" class="invalid-feedback">
                            <div *ngIf="f.certificate.errors.required">Certificate required</div>
                        </div>
                      </div>

                      <div class="form-group col-4">
                        <label>Upload Resume *</label>
                        <input type="file" formControlName="resume" (change)="handleFileInput($event)" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.resume.errors }" />
                        <div *ngIf="submitted && f.resume.errors" class="invalid-feedback">
                            <div *ngIf="f.resume.errors.required">Resume is required</div>
                        </div>
                      </div>
                    </div>

                    <img [src]="fileArraData" class="img-fluid" alt="" srcset="">


                    <div class="form-group form-check">
                        <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.acceptTerms.errors }" />
                        <label for="acceptTerms" class="form-check-label">I hereby declare and certify that all the statements made in this application are true and correct to the best of my knowledge and belief. If any of the particulars furnished by me are found to be incorrect or suppressed, my candidature is liable to be rejected at any stage during or after selection process. Further, I understand that this position is purely temporary on contract basis, if it is found after my appointment at the centre that the particulars furnished by me are incorrect or suppressed, my services are liable to be terminated without any notice.</label>
                        <!-- <div *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback">Accept Ts & Cs is required</div> -->
                    </div>
                    <div class="text-center">
                        <button class="btn btn-primary mr-1">Save And Continue</button>
                        <!-- <button class="btn btn-secondary" type="reset" (click)="onReset()">Cancel</button> -->
                    </div>
                </form>
            </div>
          </div>

        </div>
      </div>



    </div>
  </section>
  <!-- section close -->

  <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">
    <div class="row">
      <div class="col-sm-12">
        <div>
          <h6 class="head-title margin-top-8"><span>Select Image File</span></h6>
        </div>
      </div>
      <div class="col-sm-6">


          <input type="file" id="customFile" name="uploadedImage"
            (change)="onFileSelect($event)" #UploadFileInput>

          <!-- <label for="customFile">{{fileInputLabel || 'Choose File'}}</label> -->


      </div>

      <div class="col-sm-6"> <button class="btn btn-primary" type="submit">Upload</button> </div>

    </div>
  </form>

</div>
<!-- content close -->

<style>
  .apy_before{
    background: black;
    font-size: 10px;
    line-height: 15px;
    padding: 5px 0px;
  }
  .appy_now_cls{
    background: linear-gradient(to right, #eb3349, #f45c43);
    color: #fff;
    padding: 0px 10px;
    border-radius: 10px;
    position: absolute;
    right: 20px;
  }
  .appy_now_cls.inactive{
    background: grey;
    border: 0px;
  }
  .appy_now_cls.inactive:hover{
    background: grey;
  }
  .appy_now_cls:hover{
    background: linear-gradient(to left, #eb3349, #f45c43);
    cursor: pointer;
  }
  .justify_cls{
    text-align: justify;
  }
  .justify_cls i{
    font-size: 15px;
  }
  .picframe.wow:hover, .picframe .overlay, .picframe .overlay:hover{
    background: rgba(0,0,0,0.5) ;
  }
  a:hover{
    text-decoration: none;
    color: #fff;
  }
</style>



